<template>
    <div>
        <v-toolbar flat color="white">
            <v-btn small outline style="border-radius: 5px" @click="addFormModal=true">
                <v-icon class="mr-1">add</v-icon> New Form
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" label="Search" clearable></v-text-field>
        </v-toolbar>
        <v-data-table :items="forms" :headers="headers" :search="search" style="cursor: pointer">
             <template v-slot:items="props">
          <td class="justify-center layout px-0">
            <v-icon @click="deleteItem(props.item.id)">delete</v-icon>
          </td>
          <td class="text-xs-center" @click="openForm(props.item.id)">{{ props.item.name }}</td>
          <td class="text-xs-center" @click="openForm(props.item.id)">{{ props.item.description }}</td>

             </template>
        </v-data-table>

        <v-dialog v-model="addFormModal" width="500px" persistent>
            <v-card v-if="item">
                <v-toolbar flat color="white">
                    <v-toolbar-title>New Form</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="addFormModal=false">X</v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-text-field box label="Form Title" v-model="item.name"></v-text-field>
                    <v-textarea box label="What will this form be used for?" v-model="item.description"></v-textarea>
                <v-layout justify-center>
                    <v-btn flat color="primary" @click="createForm()">Save</v-btn>
                </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Api from "@/services/Api";
import draggable from "vuedraggable";
export default {
    data:()=>({
        addFormModal: false,
        forms: [],
         headers: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "Description",
          align: "center",
          value: "description",
        },
      ],
      item: {},
      search: ''
    }),
    created(){
        this.fetchForms()
    },
    methods: {
        createForm(){
            Api().post('/form', this.item).then(res=>{
                this.openForm(res.data.id)
            })
        },
        deleteItem(id){

        },
        editItem(item){

        },
        fetchForms(){
            Api().get('/forms').then(res=>{
               this.forms = res.data
            })
        },
        openForm(id){
            this.$router.push({path: '/forms/'+id})
        }
    }
}
</script>